import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

import useStyles from './styles'

const getLogo = graphql`
  {
    logo: file(relativePath: { eq: "logo512.png" }) {
      childImageSharp {
        fluid(maxWidth: 850) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`

const Logo = ({ width }) => {
  const { img } = useStyles({ width })
  const { logo } = useStaticQuery(getLogo)
  return (
    <Img
      className={img}
      fluid={logo.childImageSharp.fluid}
      alt="global-actuarial-services-logo"
    />
  )
}

export default Logo
